import { render, staticRenderFns } from "./AppBarAccountAvatar.vue?vue&type=template&id=a0295bae&"
import script from "./AppBarAccountAvatar.vue?vue&type=script&lang=ts&"
export * from "./AppBarAccountAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports